import type { BrowserClientInfo, HandshakePayload, HeartbeatPayload } from './types'

export const createHandshakePayload = (clientInfo: BrowserClientInfo): HandshakePayload => ({
  type: 'handshake',
  data: { ...clientInfo },
})

export const createHeartbeatPayload = (number: number): HeartbeatPayload => ({
  type: 'heartbeat',
  body: { number },
})
